import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { useLayout } from '~hooks/useLayout';
import { useSeo } from '~hooks/useSeo';
import Hero from '~components/hero';

import { Suspense, ErrorBoundary } from '~components/suspense';
import { UserContext } from '~contexts/user';

import PersonalData from './personal-data';
import WorkerOffer from './worker-offer';
import CustomerOffer from './customer-offer';
import Actions from './actions';
import AccountSkeleton from './skeleton';
import Unsubscribe from './unsubscribe';
import Subscription from './subscription';

import './style.scss';

const Account = () => {
  const intl = useIntl();
  useLayout({ type: 'account', displayCities: false });

  useSeo(intl.formatMessage({ id: 'containers.account.title', defaultMessage: 'Profile - Customer panel' }));

  const { user, isLoading } = useContext(UserContext);
  const { accountType } = user;

  return (
    <div className="c-page l-container">
      <Hero.Wrapper>
        <Hero.Title>{intl.formatMessage({ id: 'containers.account.headline', defaultMessage: 'Profile' })}</Hero.Title>
      </Hero.Wrapper>

      <div className="c-account l-mt2">
        <Suspense fallback={<AccountSkeleton />} isLoading={isLoading}>
          <ErrorBoundary fallback={<h2 className="l-error">Could not fetch profile data</h2>}>
            <>
              <div className="c-account__column">
                <PersonalData />
                <Actions />
                {accountType === 'client' && <Subscription />}
                <Unsubscribe />
              </div>
              <div className="c-account__column">
                {accountType === 'worker' && <WorkerOffer />}
                {accountType === 'client' && <CustomerOffer />}
              </div>
            </>
          </ErrorBoundary>
        </Suspense>
      </div>
    </div>
  );
};

export default Account;
